import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'

const optionsProgress = {
    color: '#fcee21',
    failedColor: '#874b4b',
    thickness: '7px',
    transition: {
        speed: '0.2s',
        opacity: '0.8s',
        termination: 300,
    },
    autoRevert: true,
    location: 'top',
    inverse: false,
}

Vue.use(VueProgressBar, optionsProgress)
